import { render, staticRenderFns } from "./FilterBarSort.vue?vue&type=template&id=5cb840ce&"
import script from "./FilterBarSort.vue?vue&type=script&lang=js&"
export * from "./FilterBarSort.vue?vue&type=script&lang=js&"
import style0 from "./FilterBarSort.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports